/**
 *  Enums for market-date-picker-menu slot names used to determine which row was selected
 */
var MENU_SLOT_NAMES;
(function (MENU_SLOT_NAMES) {
  MENU_SLOT_NAMES["TODAY"] = "today";
  MENU_SLOT_NAMES["YESTERDAY"] = "yesterday";
  MENU_SLOT_NAMES["THIS_WEEK"] = "this-week";
  MENU_SLOT_NAMES["LAST_WEEK"] = "last-week";
  MENU_SLOT_NAMES["THIS_MONTH"] = "this-month";
  MENU_SLOT_NAMES["LAST_MONTH"] = "last-month";
  MENU_SLOT_NAMES["THIS_YEAR"] = "this-year";
  MENU_SLOT_NAMES["LAST_YEAR"] = "last-year";
  MENU_SLOT_NAMES["CUSTOM"] = "custom";
})(MENU_SLOT_NAMES || (MENU_SLOT_NAMES = {}));

export { MENU_SLOT_NAMES as M };
